import React, {useCallback, useRef} from "react";
import Form from "../../atoms/form/form.component.js";
import Input from "../../atoms/input/input.component.js";
import {SearchBarContainer} from "./search-bar.styles.js";
function SearchBar({
  label,
  translate,
  value = "",
  onSearch,
  width = ""
}) {
  const formRef = useRef(null);
  const handleSearch = useCallback((values) => {
    if (onSearch) {
      onSearch(values.search);
    }
  }, [onSearch]);
  const handleClickSearch = useCallback(() => {
    formRef.current?.submitForm();
  }, []);
  return /* @__PURE__ */ React.createElement(SearchBarContainer, {
    width
  }, /* @__PURE__ */ React.createElement(Form, {
    innerRef: formRef,
    onSubmit: handleSearch,
    initialValues: {
      search: value
    }
  }, /* @__PURE__ */ React.createElement(Input, {
    name: "search",
    endIcon: "search",
    size: "small",
    onEndIconClick: handleClickSearch,
    translate,
    label
  })));
}
export default /* @__PURE__ */ React.memo(SearchBar);
